import { DateTime } from "luxon";

export function formatDate(val, format) {
  let dt = DateTime.fromISO(val);
  let defaultFormat = format || DateTime.DATETIME_FULL;
  return dt.toLocaleString(defaultFormat);
}

export function truncate(val, length) {
  let after = length;
  if (after === undefined) {
    after = 20;
  }
  if (val.length <= after) {
    return val;
  }
  return val.substr(0, after) + "...";
}

export function role(val) {
  if (val) {
    return val.filter(
      r =>
        r !== "uma_authorization" &&
        r !== "offline_access" &&
        r !== "craiyon_admin"
    )[0];
  }
  return "";
}
